import React from 'react';
import { Form } from 'react-final-form';
import createDecorator from 'final-form-focus';
import { TextField } from 'mui-rff';
import Button from '@mui/material/Button';
import { validate } from 'utils/validate';
import { schema } from './schema';
import { Box } from '@mui/material';

const focusOnErrors = createDecorator();

function EnviarEmailForm({ onSubmit }: any) {
  return (
    <Form
      onSubmit={onSubmit}
      decorators={[focusOnErrors]}
      validate={validate(schema)}
      render={({ handleSubmit, submitting }: any) => (
        <form onSubmit={handleSubmit} noValidate style={{width: '100%'}}>
          <Box sx={{justifyContent: 'center'}}>
            <TextField name="email"
              type="text"
              placeholder="Ex.: junior@gmail.com"
              fullWidth
              label="E-mail"
              margin="normal"
              variant="outlined"
            />
          </Box>
          <Box mt={3} sx={{display: 'flex', justifyContent: 'center'}}>
            <Button
              style={{minWidth: '220px'}}
              disabled={submitting}
              variant="contained"
              color="primary"
              type="submit"
            >
              Enviar
            </Button>
          </Box>
        </form>
      )}
    />
  );
}

export default EnviarEmailForm;
